export default __webpack_public_path__ + "static/media/google-login.abda6d53.svg";